import type { AnimationPhase } from './Tearsheet.types'

export const openingPhasesInOrder: AnimationPhase[] = [
  'scrim',
  'tearsheet',
  'closeButton',
]
export const closingPhasesInOrder = [...openingPhasesInOrder].reverse()
